/**
 * Created by orenm on 12/10/2014.
 */

define(function(require){
    "use strict";

    var Template = require("connection-templates/relatedCompositeView.tmpl");
    var KPSnippetView = require("connection-views/KPsTab/KPSnippetView");
    var CP_CONST = require("connection-const");

    var RelatedCompositeView;
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        RelatedCompositeView = Marionette.CompositeView.extend({
            template: Template,
            className: "related-container",
            itemView: KPSnippetView,

            itemViewOptions: {
                permutation: CP_CONST.SNIPPET_PERMUTATION.RELATED,
                type: CP_CONST.REFERER_ACTION.RELATED_SNIPPET
            },
            initialize: function () {
//                LEConnection.logger.info("Initializing RelatedCompositeView");
            },

            events: {
            }

        });
    });

    return RelatedCompositeView;


});
